import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Divider,
  Button,
  LinearProgress,
  useMediaQuery,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import PhoneIcon from "@mui/icons-material/Phone";
import { useTheme } from "@mui/material/styles";

// 🖼️ apni image import karo yahan
import BgImage from "../../../assets/loginBackground.png" // change path accordingly

import BgAll  from "../../../assets/bgAll.png" // change path accordingly
import { useSelector } from "react-redux";

const PaymentStatus = ({
  status ,
   amount,
  orderId ,
  paymentMethod,
  onTimerComplete,
  
}) => {
  console.log("orderId",orderId,amount)
    const ReduxWebSocketData = useSelector(
      (state) => state.WebSocket?.WebSocketData
    );

      const ReduxOrderData = useSelector(
      (state) => state.WebSocket?.OrderData
    );
  console.log("ReduxOrderData",ReduxOrderData)
  const isSuccess = status;
  const [currentTime, setCurrentTime] = useState("");
  const [secondsLeft, setSecondsLeft] = useState(5);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

useEffect(() => {
  const now = new Date();
  const timeStr = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  const dateStr = now.toLocaleDateString([], {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  setCurrentTime(`${timeStr}, ${dateStr}`);

  if (isSuccess) {
    const timer = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onTimerComplete && onTimerComplete();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }
}, [isSuccess, onTimerComplete]);


  return (
    <Box
      sx={{
        position: isMobile ? "relative" : "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        backgroundImage: `url(${BgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: isMobile ? "#ffffff" : "rgba(0,0,0,0.4)",
        backdropFilter: isMobile ? "none" : "blur(4px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1200,
      }}
    >
      <Box
        sx={{
          width: isMobile ? "100%" : "90%",

          maxWidth: 400,
           backgroundImage: `url(${BgAll})`,
            backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
          //background: "linear-gradient(171deg, #f7e9e9 0%, #e0edff 100%)",
          borderRadius: isMobile ? 0 : "20px",
          boxShadow: isMobile ? "none" : 6,
          textAlign: "center",
          p: 3,
          height: isMobile ? "100vh" : "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* ✅ Status Icon */}
        <Box sx={{ mb: 2 }}>
          {isSuccess ? (
            <CheckCircleIcon sx={{ color: "#22C55E", fontSize: 60 }} />
          ) : (
            <ErrorIcon sx={{ color: "#EF4444", fontSize: 60 }} />
          )}
        </Box>

        {/* ✅ Status Text */}
        <Typography
          variant="h6"
          sx={{ color: isSuccess ? "#16A34A" : "#EF4444", fontWeight: 600 }}
        >
          {isSuccess ? "Paid successfully to" : "Payment Failed!"}
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 700, mt: 0.5 }}>
          Daalchini
        </Typography>

        {/* ✅ Amount */}
        <Typography variant="h4" sx={{ fontWeight: 600, my: 1 }}>
          ₹{ReduxOrderData.amount}
        </Typography>

        <Divider sx={{ width: "80%", my: 1, mx: "auto" }} />

        {/* ✅ Order Details */}
        <Box sx={{ textAlign: "center", mt: 1 }}>
          <Typography variant="body2" sx={{ color: "#374151" }}>
            Order ID: <b>{ReduxOrderData.orderId}</b>
          </Typography>
          <Typography variant="body2" sx={{ color: "#6B7280" }}>
            Payment Method: <b>{ReduxWebSocketData.pgName}</b>
          </Typography>
          <Typography variant="body2" sx={{ color: "#6B7280" }}>
            {currentTime}
          </Typography>
        </Box>

        {/* ✅ Timer for success */}
{isSuccess && (
  <Box sx={{ width: "80%", mt: 2, mx: "auto" }}>
    <LinearProgress
      variant="determinate"
      value={(5 - secondsLeft) * 20} // ✅ 5 sec = 20% each second
      sx={{
        height: 8,
        borderRadius: 4,
        "& .MuiLinearProgress-bar": { backgroundColor: "#16A34A" },
      }}
    />
    <Typography variant="caption" sx={{ color: "#6B7280" }}>
      Redirecting in {secondsLeft}s...
    </Typography>
  </Box>
)}


        {/* ✅ Refund Info for failed payments */}
        {!isSuccess && (
          <Typography
            variant="body2"
            sx={{
              mt: 2,
              color: "#6B7280",
              maxWidth: "80%",
              mx: "auto",
            }}
          >
            If your money is deducted, it will be auto refunded within 24 hrs.
          </Typography>
        )}

        {/* ✅ Contact Button */}
        <Button
          startIcon={<PhoneIcon />}
          sx={{
            mt: 3,
            color: "#6B7280",
            textTransform: "none",
            fontWeight: 500,
          }}
        >
          Contact Us
        </Button>
      </Box>
    </Box>
  );
};

export default PaymentStatus;
